import { memo } from "react";
import { useSelector } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

import {
  COLLECTIONS_PLAN_TYPE,
  OVERRIDES_PLAN_TYPE,
} from "../../consts/planTypes";
import { palette } from "../../theme/palette";

import { formatMinutesToHHMM } from "../../utils/date";
import { getParcels } from "../../utils/routes";

import {
  getMatrixProfileType,
  volumeDataSelector,
} from "../../reducers/matrixProfile/selectors";

import {
  ClockIcon,
  CollectionIcon,
  MapLocationIcon,
  ParcelIcon,
  RoadIcon,
  WarningIcon,
} from "../Icons";
import { TextIconInfo } from "./TextIconInfo";
import { View } from "../View";

const useStyles = makeStyles({
  text: {
    fontSize: "12px",
    color: palette.typography.white.high,
    lineHeight: "16px",
  },
  space: {
    width: "12px",
  },
  leftSpace: {
    marginLeft: "5px",
  },
  warningIcon: {
    width: "12px",
    height: "12px",
    fill: "#FFD500",
  },
  parcelIcon: {
    width: "11px",
    height: "12px",
    fill: palette.typography.white.medium,
  },
  collectionIcon: {
    width: "12px",
    height: "12px",
    fill: palette.typography.white.medium,
  },
  stopsIcon: {
    width: "12px",
    height: "12px",
    fill: palette.typography.white.medium,
    marginBottom: "-2px",
  },
  clockIcon: {
    width: "12px",
    height: "12px",
    fill: "#51D61F",
  },
  spaceBetween: {
    display: "flex",
    justifyContent: "space-between",
  },
  exceptions: {
    width: "60%",
  },
});

export const ExtendedCardInfo = memo(({ route }) => {
  const volumeData = useSelector(volumeDataSelector);
  const planType = useSelector(getMatrixProfileType);
  const styles = useStyles();

  if (planType === COLLECTIONS_PLAN_TYPE || !volumeData || !route) return null;
  const isOverridePlan = planType === OVERRIDES_PLAN_TYPE;

  return (
    <>
      {volumeData && (
        <View className={styles.spaceBetween}>
          <TextIconInfo
            keyName={(route.stops || []).length}
            icon={
              <View className={styles.leftSpace}>
                <MapLocationIcon className={styles.stopsIcon} />
              </View>
            }
          />
          <TextIconInfo
            keyName={getParcels(route)}
            icon={
              <ParcelIcon
                className={clsx(styles.parcelIcon, styles.leftSpace)}
              />
            }
          />
          <TextIconInfo
            keyName={(route.scheduledCollections || []).length}
            hide={isOverridePlan}
            icon={
              <CollectionIcon
                className={clsx(styles.collectionIcon, styles.leftSpace)}
              />
            }
          />
          <TextIconInfo
            keyName={route?.routeOptimisation?.routeMileage || 0}
            hide={isOverridePlan}
            icon={
              <RoadIcon
                className={clsx(styles.collectionIcon, styles.leftSpace)}
              />
            }
          />
          <TextIconInfo
            keyName={
              !route.routeOptimisation
                ? "??:??"
                : formatMinutesToHHMM(route?.routeOptimisation?.opportunityTime)
            }
            hide={isOverridePlan}
            icon={
              <ClockIcon className={clsx(styles.clockIcon, styles.leftSpace)} />
            }
          />
        </View>
      )}

      {route && volumeData && !isOverridePlan && (
        <View className={clsx(styles.spaceBetween, styles.exceptions)}>
          <TextIconInfo
            keyName={"Service"}
            value={
              route.routeOptimisation
                ? route.routeOptimisation.serviceExceptions
                : "?"
            }
            icon={
              !!route.routeOptimisation?.serviceExceptions ? (
                <WarningIcon
                  className={clsx(styles.warningIcon, styles.leftSpace)}
                />
              ) : (
                ""
              )
            }
          />
          <TextIconInfo
            keyName={"Duty"}
            value={
              route.routeOptimisation
                ? route.routeOptimisation.dutyExceptions
                : "?"
            }
            icon={
              !!route.routeOptimisation?.dutyExceptions && (
                <WarningIcon
                  className={clsx(styles.warningIcon, styles.leftSpace)}
                />
              )
            }
          />
        </View>
      )}
    </>
  );
});
